// Fuentes de datos para el gráfico de ROI por servicio

export interface ROIServiceSource {
  name: string; // Nombre de la fuente
  url: string; // URL de la fuente
  year: string; // Año de publicación
  organization: string; // Organización que publicó el estudio
  description: string; // Breve descripción del estudio
}

export const roiServiceSources: ROIServiceSource[] = [
  {
    name: 'Estudio de ROI en Servicios Tecnológicos',
    url: 'https://www.gartner.com/en/information-technology/insights/business-value-of-it',
    year: '2023',
    organization: 'Gartner',
    description:
      'Análisis detallado del retorno de inversión en diferentes servicios tecnológicos para empresas de diversos tamaños.',
  },
  {
    name: 'Informe de Inversión en Transformación Digital',
    url: 'https://www.mckinsey.com/business-functions/mckinsey-digital/our-insights/the-digital-transformation-roi',
    year: '2023',
    organization: 'McKinsey & Company',
    description:
      'Estudio sobre el ROI de diferentes iniciativas de transformación digital y su impacto en el rendimiento empresarial.',
  },
  {
    name: 'Análisis Comparativo de Inversiones Tecnológicas',
    url: 'https://www.forrester.com/report/research-digital-transformation',
    year: '2023',
    organization: 'Forrester Research',
    description:
      'Investigación sobre el retorno económico de diferentes inversiones tecnológicas, incluyendo desarrollo web, ERP y consultoría.',
  },
  {
    name: 'Métricas de Éxito en Implementación de ERP',
    url: 'https://www.deloitte.com/global/en/services/consulting/services/erp-implementation-success-metrics.html',
    year: '2023',
    organization: 'Deloitte',
    description:
      'Estudio especializado en el ROI de implementaciones de ERP y factores que influyen en su éxito.',
  },
  {
    name: 'Valor Empresarial de la Capacitación Tecnológica',
    url: 'https://www.accenture.com/us-en/insights/technology/technology-training-roi',
    year: '2023',
    organization: 'Accenture',
    description:
      'Análisis del retorno de inversión en programas de capacitación tecnológica y su impacto en la productividad.',
  },
];

// Mapeo de servicios a fuentes específicas
export const serviceToSourceMap: Record<string, number[]> = {
  'Desarrollo Web': [0, 2], // Índices de las fuentes relevantes para Desarrollo Web
  ERP: [0, 3], // Índices para ERP
  Transformación: [1, 2], // Índices para Transformación Digital
  Consultoría: [0, 2], // Índices para Consultoría
  Capacitación: [0, 4], // Índices para Capacitación
};
